<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay" v-on:click="close(false)"></div>
      <div class="modalContent">
        <h4>Tambah Alamat</h4>
        <div class="addressForm" v-if="state === 0">
          <div class="fieldGroup search">
            <label>Tentukan Pengiriman</label>
            <div class="fieldCnt search">
              <input type="text" class="field" placeholder="Cari nama jalan / gedung / perumahan"
                v-model="form.q.model" v-on:input="searchAddress">
              <div class="searchIcon"></div>
            </div>
          </div>
          <div class="useCurrentLocation">
            Gunakan Lokasi Saat Ini
          </div>
          <div class="addresses">
            <div class="addressItem" v-for="(item, i) in results" :key="`address-q-${i}`"
              v-on:click="selectAddress(i, item)">
              <h4>{{item.name}}</h4>
              <p>{{item.formatted_address}}</p>
            </div>
          </div>
        </div>
        <div class="addressMap" v-if="state === 1 && sAddress">
          <div class="mapSelector">
            <div class="map"></div>
            <div class="mapAddress">
              <h4>{{sAddress.name}}</h4>
              <p>{{sAddress.formatted_address}}</p>
            </div>
          </div>
          <div class="mapInfo">
            <h5>Nama lokasi tidak sesuai alamatmu?</h5>
            <p>Tenang, kamu akan isi alamat nanti. Pastikan pinpoint sudah sesuai dulu</p>
          </div>
        </div>
        <div class="addressDetail" v-if="state === 2">
          <div class="fieldGroup">
            <label>Label</label>
            <div class="fieldCnt">
              <input type="text" class="field" placeholder="Rumah / kantor / apartment"
                v-model="form.label.model">
            </div>
          </div>
          <div class="fieldGroup">
            <label>Alamat Lengkap</label>
            <div class="fieldCnt" :class="{hasError: form.address.error}">
              <textarea rows="2" class="field" placeholder="Alamat lengkap..."
                 v-on:input="fieldChanged('address')"
                v-model="form.address.model"></textarea>
              <div class="fieldError" v-if="form.address.error">
                {{form.address.error}}
              </div>
            </div>
          </div>
          <div class="fieldGroup fg2">
            <div class="fieldCnt" :class="{hasError: form.province.error}">
              <label>Provinsi</label>
              <div class="loadingField" v-if="loadingProvince"></div>
              <select class="field" v-else v-model="form.province.model"
                v-on:change="provinceChanged(false)">
                <option v-for="(item, i) in provinces" :key="`prov${i}`"
                  :value="item.province_id">{{item.province}}</option>
              </select>
              <div class="fieldError" v-if="form.province.error">
                {{form.province.error}}
              </div>
            </div>
            <div class="fieldCnt" :class="{hasError: form.city.error}">
              <label>Kota / Kabupaten</label>
              <div class="loadingField" v-if="loadingCity"></div>
              <select class="field" v-model="form.city.model" v-else
                v-on:change="fieldChanged('city')">
                <option v-for="(item, i) in cities" :key="`prov${i}`"
                  :value="item.city_id">{{item.city_name}}</option>
              </select>
              <div class="fieldError" v-if="form.city.error">
                {{form.city.error}}
              </div>
            </div>
          </div>
          <div class="fieldGroup fg2" v-if="1>2">
            <div class="fieldCnt fc1">
              <label>Kecamatan</label>
              <select class="field">
                <option>Mampang</option>
                <option>Pasar Minggu</option>
                <option>Kemayoran</option>
              </select>
            </div>
            <div class="fieldCnt fc2">
              <label>Desa</label>
              <select class="field">
                <option>Kalibata Pulo</option>
              </select>
            </div>
          </div>
          <div class="fieldGroup fg2">
            <div class="fieldCnt fc1" :class="{hasError: form.district.error}">
              <label>Kecamatan</label>
              <input type="text" class="field" placeholder="Kecamatan..."
                v-model="form.district.model" v-on:input="fieldChanged('district')">
              <div class="fieldError" v-if="form.district.error">
                {{form.district.error}}
              </div>
            </div>
            <div class="fieldCnt fc2">
              <label>Desa</label>
              <input type="text" class="field" placeholder="Desa..."
               v-model="form.subDistrict.model">
            </div>
          </div>
          <div class="fieldGroup fg2">
            <div class="fieldCnt fc1">
              <label>RT/RW</label>
              <input type="text" class="field" placeholder="RT/RW"
                v-model="form.rtrw.model">
            </div>
            <div class="fieldCnt fc1">
              <label>Kode Pos</label>
              <input type="text" class="field" placeholder="Kode pos..."
                v-model="form.postalCode.model">
            </div>
          </div>
          <div class="fieldGroup">
            <label>Catatan untuk kurir</label>
            <div class="fieldCnt">
              <input type="text" class="field" placeholder="Catatan (optional)..."
                v-model="form.notes.model">
              <div class="hint">Warna rumah, patokan, pesan khusus, dll.</div>
            </div>
          </div>
          <div class="fieldGroup fg2">
            <div class="fieldCnt" :class="{hasError: form.recipient.error}">
              <label>Nama penerima</label>
              <input type="text" class="field" placeholder="Nama penerima..."
                v-model="form.recipient.model" v-on:input="form.recipient.error = null">
              <div class="fieldError" v-if="form.recipient.error">{{form.recipient.error}}</div>
            </div>
            <div class="fieldCnt" :class="{hasError: form.phone.error}">
              <label>Nomor HP</label>
              <input type="text" class="field" placeholder="Nomor HP..."
                v-model="form.phone.model" v-on:input="form.phone.error = null">
              <div class="fieldError" v-if="form.phone.error">{{form.phone.error}}</div>
            </div>
          </div>
        </div>
        <div class="modalAction">
          <button class="btn secondary" type="button"
            v-on:click="close(false)" v-if="!loading">
            <span v-if="state === 0 || state > 1">Batal</span>
            <span v-else>Sebelumnya</span>
          </button>
          <button class="btn primary" :class="{loading: loading, disabled: state === 0}"
            v-on:click="handleSubmit">
            <span v-if="state < 2">Berikutnya</span>
            <span v-else>Simpan Alamat</span>
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      d: null,
      form: {
        q: { model: '' },
        rtrw: { model: '', error: null },
        postalCode: { model: '', error: null },
        label: { model: '', error: null },
        address: { model: '', error: null },
        notes: { model: '', error: null },
        recipient: { model: '', error: null },
        phone: { model: '', error: null },
        province: { model: '0', error: null },
        city: { model: '0', error: null },
        district: { model: '', error: null },
        subDistrict: { model: '', error: null },
      },
      next: null,
      loading: false,
      searchTimer: null,
      results: [],
      sAddress: null,
      state: 2,

      loadingProvince: true,
      provinces: [],

      loadingCity: false,
      cities: [],
    };
  },
  methods: {
    open(d, n) {
      this.form.q.model = '';
      this.loading = false;
      this.state = 2;
      this.next = n;
      this.show = true;
      this.d = d;

      this.form.label.model = (d && d.label) ? d.label : '';
      this.form.address.model = (d && d.userAddress) ? d.userAddress : '';
      this.form.province.model = (d && d.provinceId) ? d.provinceId.toString() : '0';
      this.form.city.model = (d && d.cityId) ? d.cityId.toString() : '0';
      this.form.district.model = (d && d.district) ? d.district : '';
      this.form.subDistrict.model = (d && d.subDistrict) ? d.subDistrict : '';
      this.form.rtrw.model = (d && d.rtrw) ? d.rtrw : '';
      this.form.postalCode.model = (d && d.postalCode) ? d.postalCode : '';
      this.form.notes.model = (d && d.notes) ? d.notes : '';
      this.form.recipient.model = (d && d.recipient) ? d.recipient : '';
      this.form.phone.model = (d && d.phone) ? d.phone : '';

      this.cities = [{ city_name: '-- Pilih kota --', city_id: '0' }];
      this.loadingCity = false;
      this.provinces = [{ province: '-- Pilih provinsi --', province_id: '0' }];
      this.loadingProvince = true;
      this.getProvinces();
    },
    fieldChanged(field) {
      this.form[field].error = null;
    },
    getProvinces() {
      this.$http.get(this.$config.uri('misc/provinces')).then((r) => {
        this.loadingProvince = false;
        if (r.data.status === 200) this.provinces.push(...r.data.data);
        if (this.form.province.model !== '0') this.provinceChanged(true);
      });
    },
    provinceChanged(prd) {
      const provinceId = this.form.province.model;
      if (provinceId === '0') return;
      this.form.province.error = null;
      this.loadingCity = true;
      if (!prd) this.form.city.model = '0';
      this.cities = [{ city_name: '-- Pilih kota --', city_id: '0' }];
      this.$http.get(this.$config.uri(`misc/province/${provinceId}/cities`)).then((r) => {
        this.loadingCity = false;
        if (r.data.status === 200) this.cities.push(...r.data.data);
      });
    },
    selectAddress(i, item) {
      this.sAddress = item;
      this.state = 1;
    },
    searchAddress() {
      if (this.searchTimer) clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.$http.post(this.$config.uri('user/address/search/google'), {
          q: this.form.q.model,
        }).then((r) => {
          this.results = (r.data.status === 200) ? r.data.data : [];
        });
      }, 500);
    },
    handleSubmit() {
      if (this.state === 1) {
        this.state = 2;
        this.form.address.model = this.sAddress.formatted_address;
        this.form.recipient.model = this.$session.get('icw_shb_name');
        this.form.phone.model = this.$session.get('icw_shb_phone');
        return;
      }
      const formData = {
        // name: this.sAddress.name,
        // formattedAddress: this.sAddress.formatted_address,
        // placeId: this.sAddress.place_id,
        // lat: this.sAddress.lat,
        // lng: this.sAddress.lng,
        userAddress: this.form.address.model,
        label: this.form.label.model,
        notes: this.form.notes.model,
        recipient: this.form.recipient.model,
        phone: this.form.phone.model,
        provinceId: this.form.province.model,
        provinceName: '',
        cityId: this.form.city.model,
        cityName: '',
        district: this.form.district.model,
        subDistrict: this.form.subDistrict.model,
        rtrw: this.form.rtrw.model,
        postalCode: this.form.postalCode.model,
      };
      if (!formData.label || formData.label === '') formData.label = 'Rumah';
      if (!formData.userAddress || formData.userAddress === '') {
        this.form.address.error = 'Mohon isi alamat lengkap';
        return;
      }
      if (formData.provinceId === '0') {
        this.form.province.error = 'Mohon pilih provinsi pengiriman';
        return;
      }
      if (formData.cityId === '0') {
        this.form.city.error = 'Mohon pilih kota pengiriman';
        return;
      }
      if (!formData.district || formData.district === '') {
        this.form.district.error = 'Mohon isi kecamatan';
        return;
      }
      if (!formData.recipient || formData.recipient === '') {
        this.form.recipient.error = 'Mohon isi nama penerima paket';
        return;
      }
      if (!formData.phone || formData.phone === '') {
        this.form.phone.error = 'Mohon isi no. HP penerima';
        return;
      }
      // eslint-disable-next-line
      for (const item of this.provinces) {
        if (item.province_id === formData.provinceId) {
          formData.provinceName = item.province;
          break;
        }
      }
      // eslint-disable-next-line
      for (const item of this.cities) {
        if (item.city_id === formData.cityId) {
          formData.cityName = item.city_name;
          break;
        }
      }
      if (this.d) formData.id = this.d.id;
      this.loading = true;
      this.$http.post(this.$config.uri('user/address'), formData).then((r) => {
        this.loading = false;
        if (r.data.status !== 200) {
          return;
        }
        this.close(true, r.data.data);
      });
    },
    close(b, v) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, v);
    },
  },
};
</script>

<style scoped lang="scss">
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 9997;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.5);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 80px;
      border-radius: 5px;
      margin-top: -20px;
      // text-align: center;
      overflow: hidden;
      max-width: none;
      width: 540px;
      @media (max-width: 680px) {
        width: auto;
        left: 10px; right: 10px;
        padding: 30px;
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 15px;
        color: #444;
      }
      .addressForm{
        min-height: 200px;
      }
      .addressDetail{
        margin: 0 -80px -30px;
        padding: 20px 80px;
        box-sizing: border-box;
        border-top: #eee 1px solid;
        max-height: 460px;
        overflow-y: auto;
        .fieldGroup{
          .field{
            font-size: 16px;
            padding: 10px 12px;
          }
          .fieldError{
            margin-top: 4px;
          }
        }
      }
      .useCurrentLocation{
        border-radius: 50px;
        padding: 10px 20px;
        padding-left: 42px;
        margin: 0 0 6px;
        font-size: 15px;
        position: relative;
        display: inline-block;
        transition: all .3s ease;
        cursor: pointer;
        &:hover{
          background-color: #eee;
          box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
        }
        &:before{
          content: "";
          position: absolute;
          left: 10px; top: 7px;
          width: 26px; height: 26px;
          background-image: url(../assets/gps.png);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .65;
        }
      }
      .addresses{
        margin: 0 -40px -30px;
        max-height: 340px;
        overflow-y: auto;
        border-top: #eee 1px solid;
        .addressItem{
          cursor: pointer;
          padding: 12px 40px;
          &:hover{
            background-color: #f5f5fe;
          }
          h4{
            margin: 0 0 3px;
            font-size: 17px;
            font-weight: 600;
          }
          p{
            margin: 0;
            font-size: 13px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #767676;
          }
        }
      }
      .fieldGroup{
        &.search{
          margin-bottom: 4px;
        }
      }
      .loadingField{
        height: 44px;
        background-color: #e5e5e5;
        background-image: url(../assets/loading.svg);
        background-size: 26px auto;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 5px;
        opacity: .65;
      }
      .fieldCnt.search{
        position: relative;
        .field{
          padding: 10px 10px 11px;
          padding-left: 46px;
          background-color: #eee;
          border-color: #eee;
          transition: all .3s ease;
          &:focus{
            background-color: #fff;
          }
        }
        .searchIcon{
          position: absolute;
          left: 10px; top: 10px;
          width: 26px; height: 26px;
          background-image: url(../assets/search.png);
          background-size: 20px auto;
          background-position: center;
          background-repeat: no-repeat;
        }
      }
      .addressMap{
        .mapSelector{
          border-radius: 5px;
          overflow: hidden;
          box-shadow: 0 0 6px rgba(0, 0, 0, .2);
          .map{
            background-color: #eee;
            height: 260px;
          }
          .mapAddress{
            padding: 14px 16px 16px;
            h4{
              margin: 0 0 3px;
              font-size: 16px;
              font-weight: 600;
            }
            p{
              margin: 0;
              font-size: 14px;
              color: #767676;
            }
          }
        }
        .mapInfo{
          margin-top: 16px;
          background-color: #fffef7;
          border: #f6cf06 1px solid;
          padding: 10px 20px;
          border-radius: 5px;
          h5{
            margin: 0;
          }
          p{
            margin: 0;
            font-size: 15px;
          }
        }
      }
      .modalAction{
        margin: 30px -80px -30px;
        padding: 10px 30px;
        text-align: right;
        border-top: #eee 1px solid;
        @media (max-width: 680px) {
          margin: 30px -30px -30px;
        }
        .btn{
          margin-left: 10px;
          padding: 0 16px;
          font-size: 18px;
          font-weight: 600;
          border-radius: 3px;
        }
      }
    }
  }
</style>
